// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreatorsSafe } from 'util/safeDispatch';
import { type IntlShape, injectIntl } from 'react-intl';
import { getPorts } from 'state/selectors';
import { setPorts } from 'state/commands/adminPropertiesCommands';
import type { Dispatch } from 'state/types';
import type { Ports } from 'state/types/serverTypes';

import localizedStrings from 'util/localizedStrings';

type Props = {
  intl: IntlShape,
  label: Object,
  onPortChanged: Function,
  portKey: string,
  serverPorts: Ports,
  setPorts: Function,
  defaultPort: number,
};

type State = {
  disabled: boolean,
  newPort: number,
};

class PortsRow extends Component<Props, State> {
  updatePorts: Function;
  handleButtonClick: Function;

  constructor() {
    super();
    this.state = {
      disabled: true,
      newPort: -1,
    };
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.updatePorts = this.updatePorts.bind(this);
  }

  async updatePorts(ports: Ports) {
    const { onPortChanged, setPorts } = this.props;
    await setPorts(ports);
    this.setState({ disabled: true, newPort: -1 });
    onPortChanged();
  }

  handleButtonClick = event => {
    const key = event.target.id;
    if (this.state.newPort === -1) {
      this.setState({ disabled: false });
    } else {
      this.updatePorts({ [key]: this.state.newPort });
    }
  };
  handleCancel = event => {
    this.setState({ disabled: true, newPort: -1 });
  };

  handleChangeInput = event => {
    let newValue = parseInt(event.target.value, 10);
    if (newValue > 65535) {
      newValue = 65535;
    }
    if (newValue < 0) {
      newValue = 0;
    }
    this.setState({ newPort: newValue });
  };

  render() {
    const {
      intl: { formatMessage },
      label,
      portKey,
      serverPorts,
      defaultPort,
    } = this.props;
    return (
      <div className="columns">
        <div className="column is-two-fifths">
          <span className="is-block">{formatMessage(label)}</span>
          <span className="help is-indented">
            {formatMessage(localizedStrings.PORT_DEFAULT)} {defaultPort}
          </span>
        </div>
        <div className="column is-one-fifth">
          <input
            className={`input ${this.state.disabled ? 'is-static' : ''}`}
            data-test-name={portKey + '-value'}
            maxLength="5"
            value={
              this.state.newPort === -1
                ? serverPorts[portKey]
                : this.state.newPort
            }
            onChange={this.handleChangeInput}
            type="number"
            disabled={this.state.disabled}
          />
        </div>
        <div className="column has-text-left">
          <a
            className={
              this.state.disabled ? 'button' : 'button is-primary is-outlined'
            }
            id={portKey}
            data-test-name={portKey}
            onClick={this.handleButtonClick}
          >
            {this.state.disabled
              ? formatMessage(localizedStrings.CHANGE)
              : formatMessage(localizedStrings.SAVE)}
          </a>
          <a
            className={
              this.state.disabled
                ? 'is-hidden'
                : 'button is-indented is-dark is-outlined'
            }
            id="cancel"
            data-test-name={portKey + '-cancel'}
            onClick={this.handleCancel}
          >
            {formatMessage(localizedStrings.CANCEL)}
          </a>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    serverPorts: getPorts(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      setPorts,
    })
)(injectIntl(PortsRow));



// WEBPACK FOOTER //
// ./src/view/Pages/GlobalSettingsPages/PortsRow.js